module.exports = __webpack_public_path__ + "img/bg-dashboard.6d113765.jpg";